export const MAP_SITE_TAB_FORM = {
  ROOT_SITES: 'rootSites',
  COUNT_AS: 'countAs',
  SITE_TYPE_IDS: 'siteTypeIds',
};

export const SITE_COUNT_AS_VALUES = {
  SITES: 'sites',
  OCCUPANTS: 'occupants',
};
